import type { FileEntry } from '@/lib/api/generated/model';
import type { Previewability } from './types';
import { classifyFileEntry } from './fileClassification';

/**
 * How this file's content can be shown.
 *
 * A named read over {@link classifyFileEntry}, which owns the one extension and
 * content-type table this app has. Keeping the signature means no caller of this
 * function changed when the Kind column arrived; keeping the *table* in one place
 * means the Kind column and the preview pane cannot come to different conclusions
 * about the same file (spec 059 FR-005).
 */
export function classifyPreviewability(entry: FileEntry): Previewability {
  return classifyFileEntry(entry).previewability;
}
